export default __webpack_public_path__ + "static/media/CH.1ef26d80.png";